var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOfficialB = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_official_b_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  fill: "#FF4600"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.984 10.5H4.446V3.497H7.89c1.28 0 1.994.798 1.994 1.785 0 .882-.566 1.47-1.218 1.606.746.115 1.355.861 1.355 1.722 0 1.082-.725 1.89-2.037 1.89m-2.31-5.922v1.816h1.963c.63 0 .987-.378.987-.902 0-.526-.357-.914-.987-.914zm0 2.898v1.943H7.69c.672 0 1.071-.368 1.071-.977 0-.525-.367-.966-1.071-.966z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_official_b_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export default SvgIconOfficialB;